const {REACT_APP_AWS_CONFIG} = process.env;

const awsconfig = JSON.parse(REACT_APP_AWS_CONFIG);

export default awsconfig;
